// dependencies
import React from "react";
import PropTypes from "prop-types";

// components
import {
  List,
  ListItem,
} from "@cloudspire/legacy-resources/src/components/List";

// containers
import BookingDiscountCode from "./Code";

const errorRegexp =
  /^Les codes de promotions suivants n'ont pas été trouvés : ([A-Z0-9, ]+)$/;

function DiscountCodeList(props) {
  const { name, parameterList, bookingEstimateResponse, errorList, onChange } =
    props;

  const discountCodes = parameterList?.[name] ?? [];

  /**
   * Gère la suppression d'un code.
   */
  function handlePressDelete(discount) {
    const discountIndex = discountCodes.indexOf(discount);

    if (discountIndex > -1) {
      onChange({
        target: {
          name,
          value: discountCodes.filter((_, index) => index !== discountIndex),
        },
      });
    }
  }

  const estimateDiscounts =
    bookingEstimateResponse.data?.data?.discountList ?? [];

  const invalidCodeListMatch = errorRegexp.exec(errorList?.discount_codes);
  const invalidDiscountCodeList = [];
  if (invalidCodeListMatch) {
    invalidDiscountCodeList.push(...invalidCodeListMatch[1].split(", "));
  }

  return (
    <List gutter={1}>
      {discountCodes.map((discountCode) => {
        const estimateDiscount = estimateDiscounts.find(
          (estimateDiscount) => estimateDiscount.code === discountCode
        );

        const invalid = invalidDiscountCodeList.includes(discountCode);

        return (
          <ListItem key={discountCode}>
            <BookingDiscountCode
              key={discountCode}
              discountCode={discountCode}
              estimateDiscount={estimateDiscount}
              invalid={invalid}
              onDelete={() => handlePressDelete(discountCode)}
            />
          </ListItem>
        );
      })}
    </List>
  );
}

DiscountCodeList.propTypes = {
  name: PropTypes.string,
  parameterList: PropTypes.object,
  errorList: PropTypes.object,
  onChange: PropTypes.func,
};

export default DiscountCodeList;
